module.exports = "<a class=\"navbar-minimalize minimalize-styl-2 btn btn-primary \"\n   href=\"\"\n   ng-click=\"minimalize()\">\n    <i class=\"fa fa-bars\"></i>\n</a>"


//////////////////
// WEBPACK FOOTER
// ./src/js/directives/minimalizeSidebar/view.html
// module id = 949
// module chunks = 0